let FJRecorderManager = (function () {

  const STATE = {
    START: 'START',
    STOP: 'STOP',
    PAUSE: 'STOP',
    RESUME: 'RESUME',
  };

  let _recorder = null;
  
  // 执行过程中产生的MediaStreamTrack
  let _tracks = [];
  
  // 监听列表
  let _listenerList = []; 
  return {

    /**
     * @description recorder状态
     * @return {{PAUSE: string, STOP: string, START: string, RESUME: string}}
     */
    get state() {
      return STATE;
    },

    /**
     * 结束录制
     */
    stop: function () {
      if (!_recorder || _recorder.state === 'inactive') {
        this._clear();
        return;
      }

      _recorder.stop();
    },

    isStreamActive: function () {
      return _recorder && _recorder.stream.active;
    },

    /**
     * 录制屏幕
     * @param {boolean} microphone 是否启用麦克风
     * @param {boolean} systemAudio 是否启用设备声音
     * @param {Object} options 其他选项
     * @param {Function} streamHandler 额外媒体流handler, 应当返回一个处理后的MediaStream
     * @returns {Promise<Blob>}
     */
    recordScreen: async function (microphone = false, systemAudio = true, options = {}, streamHandler = (stream) => stream) {

      if (this.isStreamActive()) {
        throw new Error('');
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
        throw new Error('Recording screens are not supported');
      }

      // 获取麦克风媒体流
      let microphoneStream = null;
      if (microphone) {
        try {
          microphoneStream = await navigator.mediaDevices.getUserMedia({audio: {deviceId: options.audioDeviceId}});
        } catch (e) {
          throw new Error('AUDIO_INPUT_DENIED');
        }
        _tracks.push(...microphoneStream.getTracks()); // 麦克风的track
      }

      let stream;
      try {
        let options = {
          video: true
        };
        if (systemAudio) {
          options.audio = true
        }
        stream = await navigator.mediaDevices.getDisplayMedia(options);
      } catch (e) {
        // 用户可能会点击取消
        this._clear();
        throw e;
      }

      // 分享屏幕的track
      _tracks.push(...stream.getTracks());

      let videoTracks = stream.getVideoTracks();
      videoTracks[0].onended = () => {
        this.stop();
      };

      // 如果有麦克风媒体流，合并音频流后再进行录制
      if (microphoneStream) {
        let ac = new AudioContext();
        let videoTrack = stream.getVideoTracks()[0];
        let merge = ac.createChannelMerger(2);
        let microphoneSource = ac.createMediaStreamSource(microphoneStream);

        // 用户在分享屏幕界面可能不会勾选音频
        try {
          let audioSource = ac.createMediaStreamSource(stream);
          audioSource.connect(merge, 0, 0);
          audioSource.connect(merge, 0, 1);
        } catch (e) {
        }

        microphoneSource.connect(merge, 0, 0);
        microphoneSource.connect(merge, 0, 1);
        let dest = ac.createMediaStreamDestination();
        merge.connect(dest);
        stream = dest.stream;
        _tracks.push(...stream.getTracks()); // 合并流的track
        stream.addTrack(videoTrack);
      }


      // 交给外部处理，如果需要的话
      stream = streamHandler(stream);

      // 创建Recorder
      try {
        _recorder = new MediaRecorder(stream, {mimeType: "video/webm; codecs=vp9"});
      } catch (e) {
        _recorder = new MediaRecorder(stream);
      }

      // 绑定事件
      this._bindRecordEvent();
      _recorder.start();
      return new Promise((resolve, reject) => {
        _recorder.ondataavailable = (e) => {
          resolve(e.data);
        };
        _recorder.onerror = reject;
      });
    },

    /**
     * 录制网络摄像头
     * @param {boolean} microphone 是否启用麦克风
     * @param {Object} options 其他选项
     * @param {Function} streamHandler 额外媒体流handler, 应当返回一个处理后的MediaStream
     * @returns {Promise<Blob>}
     */
    recordWebcam: async function (microphone = false, options = {}, streamHandler = (stream) => stream) {
      if (this.isStreamActive()) {
        throw new Error('');
      }

      let constraints = {
        video: {
          deviceId: options.videoDeviceId,
          width: 1920,
          height: 1080
        },
      };
      if (microphone) {
        constraints.audio = {deviceId: options.audioDeviceId}
      }

      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia(constraints);
      } catch (e) {
        // 用户可能会点击取消
        this._clear();
        throw e;
      }
      _tracks.push(...stream.getTracks());


      // 交给外部处理，如果需要的话
      stream = streamHandler(stream);

      // 创建Recorder
      try {
        _recorder = new MediaRecorder(stream, {mimeType: "video/webm; codecs=vp9"});
      } catch (e) {
        _recorder = new MediaRecorder(stream);
      }

      // 绑定事件
      this._bindRecordEvent();
      // _recorder.start();
      return new Promise((resolve, reject) => {
        _recorder.ondataavailable = (e) => {
          resolve(e.data);
        };
        _recorder.onerror = reject;
      });
    },

    /**
     * 添加录制状态改变监听
     * @param {Function} listener
     */
    addStateListener: function (listener) {
      _listenerList.push(listener);
    },

    /**
     * @param state
     * @private
     */
    _changeState: function (state) {
      _listenerList.forEach(listener => {
        listener(state);
      });
    },

    /**
     * 绑定MediaRecord对象上的事件回调
     * @private
     */
    _bindRecordEvent: function () {
      if (_recorder) {
        _recorder.onpause = (e) => {
          this._changeState(STATE.PAUSE);
        };
        _recorder.onresume = (e) => {
          this._changeState(STATE.RESUME);
        };
        _recorder.onstart = (e) => {
          this._changeState(STATE.START);
        };
        _recorder.onstop = (e) => {
          this._clear();
          this._changeState(STATE.STOP);
        };
      }
    },

    /**
     * 开始录制
     */
    begin: function () {
      if (_recorder) {
        _recorder.start();
      }
    },

    /**
     * 暂停录制
     */
    pause: function () {
      if (_recorder) {
        _recorder.pause();
      }
    },

    /**
     * 继续录制
     */
    resume: function () {
      if (_recorder) {
        _recorder.resume();
      }
    },

    /**
     * 清除资源，停止流
     * @private
     */
    _clear: function () {
      _tracks.forEach(track => track.stop());
      _tracks = [];
      _recorder = null;
    },

    /**
     * 获取音频输入设备
     */
    getAudioInput: function () {
      return this._getDevices('audioinput');
    },

    /**
     * 获取视频输入设备
     * @returns {Promise<MediaDeviceInfo[]>}
     */
    getVideoInput: function () {
      return this._getDevices('videoinput');
    },

    /**
     * @param type
     * @returns {Promise<MediaDeviceInfo[]>}
     * @private
     */
    _getDevices: async function (type) {
      let devices = await navigator.mediaDevices.enumerateDevices();
      return devices.filter(item => {
        return item.kind === type && item.deviceId !== '';
      });
    }
  };
})();

export default FJRecorderManager;